import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import useForgot from '../hooks/useForgot'; // Forgot Password hook
import { useLogin } from '../hooks/useLogin'; // Login hook
import './Login.css';

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isForgotMode, setIsForgotMode] = useState(false); // Toggle for forgot password
  const [message, setMessage] = useState('');

  const {
    forgotPassword,
    error: forgotError,
    isPending: forgotLoading,
    resetError: resetForgotError,
  } = useForgot();
  const {
    login,
    error: loginError,
    isPending: loginLoading,
  } = useLogin();

  const handleLogin = async (e) => {
    e.preventDefault();
    setMessage('');

    // Trim email and password
    const trimmedEmail = email.trim();
    const trimmedPassword = password.trim();

    if (isForgotMode) {
      // Forgot password mode
      try {
        await forgotPassword(trimmedEmail);
        setMessage('Password reset link has been sent to your email.');
      } catch (err) {
        console.error('Forgot Password Error:', err);
        setMessage('Failed to send password reset link. Please try again.');
      }
    } else {
      // Login mode
      try {
        const res = await login(trimmedEmail, trimmedPassword);
        
        console.log('Login response:', res); // Debug log
        
        if (res?.success) {
          navigate('/myaccount');
        } else {
          // Prioritize the returned error message, then login hook error, then default message
          const errorMessage = res?.error || loginError || 'Login failed. Please check your credentials.';
          setMessage(errorMessage);
        }
      } catch (err) {
        console.error('Unexpected login error:', err);
        setMessage('An unexpected error occurred. Please try again.');
      }
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2>{isForgotMode ? 'Forgot Password' : 'Sign in to your account'}</h2>
        {!isForgotMode && (
          <p>
            Or{' '}
            <Link to="/signup" className="login-link">
              create a new account
            </Link>
          </p>
        )}

        {message && <div className="message-box">{message}</div>}
        {(loginError || forgotError) && (
          <div className="error-box">
            {loginError || forgotError}
          </div>
        )}

        <form className="login-form" onSubmit={handleLogin}>
          <input
            type="email"
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          {!isForgotMode && (
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          )}
          <button
            type="submit"
            className="btn"
            disabled={loginLoading || forgotLoading || (!isForgotMode && !email)}
          >
            {isForgotMode
              ? forgotLoading
                ? 'Sending link...'
                : 'Send Link to Email'
              : loginLoading
              ? 'Signing in...'
              : 'Sign in'}
          </button>
        </form>

        <button
          onClick={() => {
            setIsForgotMode((prev) => !prev);
            setMessage('');
            resetForgotError();
          }}
          className="btn forgot-btn"
        >
          {isForgotMode ? 'Back to Login' : 'Forgot Password?'}
        </button>
      </div>
    </div>
  );
}